import React, { useState, useEffect, useMemo, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Pagination, Popconfirm, Switch, Table, Tag, message, Button, Modal, Checkbox } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setCustomerClassification, setBrokerName } from "../../../../store/slices/OrgDetail";
import { DeleteTwoTone, SwapOutlined, EyeTwoTone, FolderOpenTwoTone } from "@ant-design/icons";
import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";
import {
  capitalizeWords,
  remainingViewportHeight,
} from "../../../../components/icons/ApplicationColor";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import { CustomerTopLevel } from "../../../../components/AdminComponents/MenuItems";
import Sidebar from "../../../../components/AdminComponents/SideNav";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import EditableImage from "../../../../components/icons/EditIcon";
import axiosInstance from "../../../../api/Axios";
import { accessImpersontate } from "../../../../config";
import { GetFormattedDateTime } from "../../../../components/utils/DateTimeUtils";
import AddLibraryModal from "./AddLibraryModal";

const CustomerListing = () => {
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const WrapperComponent = isCAAdmin ? CaSideNav : Sidebar;
  const wrapperProps = isCAAdmin ? CustomerTopLevel : CustomerTopLevel;
  const userInfo = useSelector((state) => state.user);
  const dispatch = useDispatch();
  // Original code - commented out to allow access in production when impersonating
  // const ImpersonateAccess = !accessImpersontate(
  //   userInfo?.data?.impersonate_acc
  // );
  // Always allow access for Customer impersonate section
  const ImpersonateAccess = true;
  const [loadAgain, setLoadAgain] = useState(false);
  const [canAdd, setCanAdd] = useState(true);
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);

  const headerClickRef = useRef(false);

  const onSelectChange = (newSelectedRowKeys) => {
    if (headerClickRef.current) {
      headerClickRef.current = false;
      return;
    }
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    preserveSelectedRowKeys: true,
    onSelectAll: (selected) => {
      headerClickRef.current = true;
      if (selected) {
        handleSelectAll();
      } else {
        setSelectedRowKeys([]);
      }
    },
    getCheckboxProps: (record) => ({
      disabled: record.can_edit === false,
    }),
  };

  const handleSelectAll = async () => {
    setLoading(true);
    try {
      const parent_key_id = userInfo?.data?.organization?.id;
      const res = await axiosInstance.get(
        `/customer/customerslist/?parent_key_id=${parent_key_id}&page_size=${itemsLength || 1000}&status=${active ? "True" : "False"}`
      );
      const allIds = (res.data?.results || []).map((item) => item.id);
      setSelectedRowKeys(allIds);
      message.success(
        `Selected all ${allIds.length} ${classification ? classification.toLowerCase() : "customer"}(s).`
      );
    } catch (err) {
      console.error("Error selecting all customers:", err);
      message.error("Failed to select all items.");
    } finally {
      setLoading(false);
    }
  };

  const [isArchiveModalOpen, setIsArchiveModalOpen] = useState(false);
  const [archiveRecord, setArchiveRecord] = useState(null);
  const [availableViews, setAvailableViews] = useState(0);
  const [customerOrganization, setCustomerOrganization] = useState("");
  const [isReturnConfirmed, setIsReturnConfirmed] = useState(false);
  const [isViewsLoading, setIsViewsLoading] = useState(false);

  const handleArchiveClick = async (record) => {
    setArchiveRecord(record);
    setIsViewsLoading(true);
    setIsReturnConfirmed(false);
    try {
      const parent_key_id = userInfo?.data?.organization?.id;
      const response = await axiosInstance.get(
        `customer/checkavailableviews/?parent_key_id=${parent_key_id}&customer_id=${record.id}`
      );
      setAvailableViews(response.data.available_views_for_return || 0);
      setCustomerOrganization(
        response.data.customer_organization || record.name
      );
      setIsArchiveModalOpen(true);
    } catch (error) {
      console.error("Error checking available views:", error);
      message.error("Failed to check available views. Please try again.");
    } finally {
      setIsViewsLoading(false);
    }
  };
  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    handleSwitchChange,
    classification,
    setLoading,
    brokerName,
  } = useCommonListing({
    userInfo,
    passSize: 15,
    passPage: 1,
    passURL: `/customer/customerslist/?parent_key_id=${userInfo?.data?.organization?.id}`,
    loadAgain: loadAgain,
    takeFromData: (res) => {
      if (res?.data?.can_edit !== undefined) {
        setCanAdd(res.data.can_edit);
      }
      return res?.data?.results;
    },
  });
  const [messageApi, contextHolder] = message.useMessage();
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;

  // Store classification in Redux when it's received
  // Store classification in Redux when it's received
  useEffect(() => {
    if (classification) {
      dispatch(setCustomerClassification(classification));
    }
  }, [classification, dispatch]);

  // Store broker name in Redux when it's received
  useEffect(() => {
    if (brokerName) {
      dispatch(setBrokerName(brokerName));
    }
  }, [brokerName, dispatch]);
  // eslint-disable-next-line no-unused-vars
  const tagColors = [
    "magenta",
    "volcano",
    "orange",
    "gold",
    "lime",
    "green",
    "cyan",
    "blue",
    "geekblue",
    "purple",
  ];
  const history = useNavigate();
  const handleRowClick = (record) => {
    if (active) {
      history(
        isCAAdmin
          ? `/ca-admin/customers/edit/${record}`
          : `/customers/edit/${record}`
      );
    }
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const CreateSuccessfull = (props) => {
    messageApi.open({
      type: "success",
      content: `Bundle has been ${props}.`,
      duration: 5,
    });
  };

  const CreateFailed = (props) => {
    messageApi.open({
      type: "error",
      content: `Bundle has not been ${props}.`,
      duration: 5,
    });
  };
  const handleDelete = async (record, status, views = 0) => {
    const updatedValues = {
      name: record.name,
      client_id: record.client_id,
      description: record.description,
      address: record.address,
      industry: record.industry,
      zipcode: record.zipcode,
      city: record.city,
      enrollment_type: record.enrollment_type,
      org_type: record.org_type,
      ein: record.ein,
      country: record.country,
      access: record.access,
      status: status,
      parent_key: userInfo?.data?.organization?.id,
      available_views_for_return: views,
      account_relationship_id: record?.account_relationships?.[0]?.id,
    };
    try {
      await axiosInstance.put(`customer/customers/?id=${record.id}`, updatedValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      LoadAPI();
      CreateSuccessfull(status ? "Unarchived" : "Archived");
    } catch (err) {
      //console.log(err);
      CreateFailed(status ? "Unarchived" : "Archived");
    }
  };

  // Create dynamic column headers based on classification
  const getColumnTitle = (defaultTitle) => {
    if (classification) {
      return defaultTitle.replace("Customer", capitalizeWords(classification));
    }
    return defaultTitle;
  };

  const showInsurerColumns = useMemo(() => {
    return data?.some((item) => item.account_relationships && item.account_relationships.length > 0);
  }, [data]);

  const columns = useMemo(() => {
    const allColumns = [
      {
        title: getColumnTitle("Customer ID"),
        dataIndex: "client_id",
        key: "client_id",
        width: 150,
      },
      {
        title: getColumnTitle("Customer Name"),
        dataIndex: "name",
        key: "name",
        width: 200,
      },
      // {
      //   title: "Address",
      //   dataIndex: "address",
      //   key: "address",
      //   ellipsis: true,
      //   width: 250,
      // },
      {
        title: `${brokerName || "Insurer"} Name`,
        dataIndex: "account_relationships",
        key: "insurer_name",
        width: 180,
        render: (rels) => rels?.[0]?.account_name || "-",
      },
      {
        title: `${brokerName || "Insurer"} ID`,
        dataIndex: "account_relationships",
        key: "insurer_id",
        width: 120,
        render: (rels) => rels?.[0]?.account_id || "-",
      },
      {
        title: capitalizeWords("Events"),
        dataIndex: "no_of_events",
        key: "no_of_events",
        width: 80,
        editable: true,
        align: "center",
        render: (text) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
              width: "100%",
            }}
          >
            {text && text !== 0 ? (
              <Tag
                color="blue"
                style={{
                  fontSize: "1.15rem",
                  width: "2.5rem",
                  height: "2.5rem",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                  fontWeight: "600",
                  padding: 0,
                }}
              >
                {text}
              </Tag>
            ) : null}
          </div>
        ),
      },
      {
        title: capitalizeWords("Users"),
        dataIndex: "no_of_learners",
        key: "no_of_learners",
        width: 80,
        editable: true,
        align: "center",
        render: (text) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
              width: "100%",
            }}
          >
            {text && text !== 0 ? (
              <Tag
                color="blue"
                style={{
                  fontSize: "1.15rem",
                  width: "2.5rem",
                  height: "2.5rem",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                  fontWeight: "600",
                  padding: 0,
                }}
              >
                {text}
              </Tag>
            ) : null}
          </div>
        ),
      },
      {
        title: capitalizeWords("Courses"),
        dataIndex: "course_count",
        key: "course_count",
        width: 80,
        align: "center",
        render: (text) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
              width: "100%",
            }}
          >
            {text && text !== 0 ? (
              <Tag
                color="blue"
                style={{
                  fontSize: "1.15rem",
                  width: "2.5rem",
                  height: "2.5rem",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                  fontWeight: "600",
                  padding: 0,
                }}
              >
                {text}
              </Tag>
            ) : (
              <Tag
                style={{
                  fontSize: "1.15rem",
                  width: "2.5rem",
                  height: "2.5rem",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                  fontWeight: "600",
                  padding: 0,
                }}
              >
                0
              </Tag>
            )}
          </div>
        ),
      },
      {
        title: getColumnTitle("Customer Type"),
        dataIndex: "org_type",
        key: "org_type",
        width: 160,
      },
      {
        title: "Industry",
        dataIndex: "industry",
        key: "industry",
        width: 140,
      },
      // {
      //   title: "Tags",
      //   dataIndex: "tags",
      //   key: "tags",
      //   width: 300,
      //   render: (tags) => (
      //     <>
      //       {Array.isArray(tags) &&
      //         tags.map((tag, index) => (
      //           <Tag color={tagColors[index % tagColors.length]} key={tag}>
      //             {tag}
      //           </Tag>
      //         ))}
      //     </>
      //   ),
      // },
      {
        title: "Created",
        dataIndex: "created_at",
        key: "created_at",
        render: GetFormattedDateTime,
        width: 120,
      },
      // {
      //   title: "Created Date",
      //   dataIndex: "createdDate",
      //   key: "createdDate",
      //   render: formatDateWithSuffix,
      // },
      {
        title: "Updated",
        dataIndex: "updated_at",
        key: "updated_at",
        render: GetFormattedDateTime,
        width: 120,
      },
      // {
      //   title: "Recurring Reset",
      //   dataIndex: "recurringReset",
      //   key: "recurringReset",
      //   width: 120,
      //   render: (val) => (val ? "Yes" : "No"),
      // },
      {
        title: capitalizeWords("actions"),
        dataIndex: "actions",
        key: "actions",
        align: "center",
        width: 120,
        fixed: "right",
        onCell: (record) => {
          return {
            onClick: (event) => {
              event.stopPropagation();
            },
          };
        },
        render: (text, record) => (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            {active && (
              record.can_edit === false ? (
                <EyeTwoTone
                  style={{
                    fontSize: "1.9rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handleRowClick(record.id)}
                  title="View"
                />
              ) : (
                <EditableImage
                  handleRowClick={handleRowClick}
                  recordId={record.id}
                />
              )
            )}
            {ImpersonateAccess && (
              <>
                {active ? (
                  <DeleteTwoTone
                    style={{
                      cursor: record.can_edit === false ? "not-allowed" : "pointer",
                      fontSize: "1.9rem",
                      marginLeft: "0.7rem",
                      opacity: record.can_edit === false ? 0.5 : 1,
                    }}
                    onClick={() => record.can_edit !== false && handleArchiveClick(record)}
                    title={record.can_edit === false ? "View Only" : "Archive"}
                    twoToneColor={record.can_edit === false ? "#d9d9d9" : "#eb2f96"}
                  />
                ) : (
                  <Popconfirm
                    title={`Unarchive ${classification ? capitalizeWords(classification) : "Customer"}`}
                    description=" "
                    onConfirm={() => record.can_edit !== false && handleDelete(record, !active)}
                    okText="Yes"
                    cancelText="No"
                    disabled={record.can_edit === false}
                    placement="leftTop"
                  >
                    <SwapOutlined
                      style={{
                        cursor: record.can_edit === false ? "not-allowed" : "pointer",
                        fontSize: "1.8rem",
                        marginLeft: "0.9rem",
                        opacity: record.can_edit === false ? 0.5 : 1,
                      }}
                      title={record.can_edit === false ? "View Only" : "Unarchive"}
                    />
                  </Popconfirm>
                )}
              </>
            )}
          </div>
        ),
      },
    ];

    if (showInsurerColumns) {
      return allColumns;
    }

    return allColumns.filter(
      (col) => col.key !== "insurer_name" && col.key !== "insurer_id"
    );
  }, [classification, brokerName, active, handleRowClick, handleDelete, ImpersonateAccess, showInsurerColumns]);

  return (
    <WrapperComponent props={wrapperProps}>
      {contextHolder}
      <CommonTopDetails
        title={
          active
            ? classification
              ? `${capitalizeWords(classification)} Summary`
              : "Customers Summary"
            : `Inactive ${classification ? capitalizeWords(classification) : "Customers"}`
        }
        titleSuffix={`${itemsLength || 0} ${classification ? classification.toLowerCase() : "customer"}(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        // marginPass="15px"
        showAddButton={ImpersonateAccess}
        filterAction={true}
        addButtonProps={{
          modalType: "Redirect",
          redirctlink: isCAAdmin
            ? "/ca-admin/customers/add"
            : "/trainery-learn/courses/add",
          disabled: canAdd === false,
        }}
        filterUrl={false}
        filterButtonProps={{
          modalType: "PopUP",
          modalProps: () => { },
        }}
        resetButtonProps={{
          modalProps: () => { },
        }}
        customContent={
          <>
            <Switch
              style={{
                backgroundColor: active ? "#50C878" : "#FF0000",
                minWidth: "90px",
              }}
              checked={active}
              disabled={loading}
              onChange={handleSwitchChange}
              checkedChildren="ACTIVE"
              unCheckedChildren="INACTIVE"
            />
            <Button
              type="primary"
              size="large"
              disabled={selectedRowKeys.length === 0}
              onClick={() => {
                setIsBulkModalOpen(true);
              }}
            >
              Bulk Action
            </Button>
          </>
        }
      />
      <div
        className="table-wrapper"
        style={{ overflowX: "auto", overflowY: "auto" }}
      >
        <Table
          rowSelection={rowSelection}
          columns={columns}
          dataSource={data}
          size="small"
          bordered
          rowKey="id"
          className="table-container"
          scroll={{
            x: 1550,
            y: `${remainingViewportHeight(23)}px`,
          }}
          onRow={(record) => ({
            onClick: (event) => {
              if (
                event.target.closest(".ant-table-cell[data-index='actions']")
              ) {
                return;
              }

              handleRowClick(record.id);
            },
          })}
          style={{ marginInline: "1rem" }}
          pagination={false}
          loading={loading}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["10", "15", "30", "50", "100"]}
          showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
      {isBulkModalOpen && (
        <AddLibraryModal
          open={isBulkModalOpen}
          onCancel={() => setIsBulkModalOpen(false)}
          selectedCustomerIds={selectedRowKeys}
          parentKeyId={userInfo?.data?.organization?.id}
          onSuccess={LoadAPI}
        />
      )}
      <Modal
        title={
          active
            ? `Archive ${customerOrganization}`
            : `Unarchive ${classification ? capitalizeWords(classification) : "Customer"}`
        }
        open={isArchiveModalOpen}
        centered
        onOk={() => {
          handleDelete(archiveRecord, false, availableViews);
          setIsArchiveModalOpen(false);
        }}
        onCancel={() => setIsArchiveModalOpen(false)}
        okText="Confirm"
        cancelText="No"
        okButtonProps={{
          disabled: availableViews > 0 && !isReturnConfirmed,
        }}
      >
        {availableViews > 0 ? (
          <>
            <p>
              Available view count for return is <b>{availableViews}</b>. Do you
              want to proceed with archiving this customer?
            </p>
            <Checkbox
              checked={isReturnConfirmed}
              onChange={(e) => setIsReturnConfirmed(e.target.checked)}
              style={{ marginTop: "1rem" }}
            >
              I confirm the return of {availableViews} views.
            </Checkbox>
          </>
        ) : (
          <p>Are you sure you want to archive this customer?</p>
        )}
      </Modal>
    </WrapperComponent>
  );
};

export default CustomerListing;
